module.exports = __webpack_public_path__ + "img/Pattern-01.304a736e.jpg";